import { render, staticRenderFns } from "./DetailConsent.vue?vue&type=template&id=93837c20&scoped=true&"
import script from "./DetailConsent.vue?vue&type=script&lang=js&"
export * from "./DetailConsent.vue?vue&type=script&lang=js&"
import style0 from "./DetailConsent.vue?vue&type=style&index=0&id=93837c20&prod&lang=css&"
import style1 from "./DetailConsent.vue?vue&type=style&index=1&id=93837c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93837c20",
  null
  
)

export default component.exports